export const AclService = {
    
    checkAcess: function () {
		if (!this.getUser()) {
			localStorage.clear()
			return false
		} else return true
	},

	logout: function () {
		if (this.getUser()) {
			localStorage.clear()
		}
		window.location = `/`
	},


	// -------------------------
	// -- token
	setToken: function (token) {
		localStorage.setItem('token_pmo', token)
	},

	getToken: function () {
		return localStorage.getItem('token_pmo')
	},
	// -------------------------


	// -------------------------
	// -- user
	setUser: function (user) {
		localStorage.setItem('user_pmo', user)
	},

	getUser: function () {
		return localStorage.getItem('user_pmo') != null
			? JSON.parse(localStorage.getItem('user_pmo'))
			: false;
	},
	// -------------------------
}